// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
button,
hr,
input {
	overflow: visible;
}
progress,
sub,
sup {
	vertical-align: baseline;
}
[type='checkbox'],
[type='radio'],
legend {
	box-sizing: border-box;
	padding: 0;
}
html {
	line-height: 1.15;
	-webkit-text-size-adjust: 100%;
}
body {
	margin: 0;
	background-color: blanchedalmond;
}
details,
main {
	display: block;
}
h1 {
	font-size: 2em;
	margin: 0.67em 0;
}
hr {
	box-sizing: content-box;
	height: 0;
}
code,
kbd,
pre,
samp {
	font-family: monospace, monospace;
	font-size: 1em;
}
a {
	background-color: transparent;
}
abbr[title] {
	border-bottom: none;
	text-decoration: underline;
	text-decoration: underline dotted;
}
b,
strong {
	font-weight: bolder;
}
small {
	font-size: 80%;
}
sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
}
sub {
	bottom: -0.25em;
}
sup {
	top: -0.5em;
}
img {
	border-style: none;
}
button,
input,
optgroup,
select,
textarea {
	font-family: inherit;
	font-size: 100%;
	line-height: 1.15;
	margin: 0;
}
button,
select {
	text-transform: none;
}
[type='button'],
[type='reset'],
[type='submit'],
button {
	-webkit-appearance: button;
}
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner,
button::-moz-focus-inner {
	border-style: none;
	padding: 0;
}
[type='button']:-moz-focusring,
[type='reset']:-moz-focusring,
[type='submit']:-moz-focusring,
button:-moz-focusring {
	outline: ButtonText dotted 1px;
}
fieldset {
	padding: 0.35em 0.75em 0.625em;
}
legend {
	color: inherit;
	display: table;
	max-width: 100%;
	white-space: normal;
}
textarea {
	overflow: auto;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
	height: auto;
}
[type='search'] {
	-webkit-appearance: textfield;
	outline-offset: -2px;
}
[type='search']::-webkit-search-decoration {
	-webkit-appearance: none;
}
::-webkit-file-upload-button {
	-webkit-appearance: button;
	font: inherit;
}
summary {
	display: list-item;
}
[hidden],
template {
	display: none;
}

/* <uniquifier>: Use a unique and descriptive class name
<weight>: Use a value from 100 to 900 */

.inter-bold {
	font-family: 'Inter', sans-serif;
	font-optical-sizing: auto;
	font-weight: 500;
	font-style: normal;
	font-variation-settings: 'slnt' 0;
}

body {
	font-family: 'Inter', sans-serif;
	font-optical-sizing: auto;
	font-weight: 300;
	font-style: normal;
	font-variation-settings: 'slnt' 0;
	color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;;;CAGC,iBAAiB;AAClB;AACA;;;CAGC,wBAAwB;AACzB;AACA;;;CAGC,sBAAsB;CACtB,UAAU;AACX;AACA;CACC,iBAAiB;CACjB,8BAA8B;AAC/B;AACA;CACC,SAAS;CACT,gCAAgC;AACjC;AACA;;CAEC,cAAc;AACf;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,uBAAuB;CACvB,SAAS;AACV;AACA;;;;CAIC,iCAAiC;CACjC,cAAc;AACf;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,iCAAiC;AAClC;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;;CAEC,cAAc;CACd,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;AACA;;;;;CAKC,oBAAoB;CACpB,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;AACA;;CAEC,oBAAoB;AACrB;AACA;;;;CAIC,0BAA0B;AAC3B;AACA;;;;CAIC,kBAAkB;CAClB,UAAU;AACX;AACA;;;;CAIC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,cAAc;CACd,cAAc;CACd,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;;CAEC,YAAY;AACb;AACA;CACC,6BAA6B;CAC7B,oBAAoB;AACrB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,0BAA0B;CAC1B,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;;CAEC,aAAa;AACd;;AAEA;uCACuC;;AAEvC;CACC,gCAAgC;CAChC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,iCAAiC;AAClC;;AAEA;CACC,gCAAgC;CAChC,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;CAClB,iCAAiC;CACjC,cAAc;AACf","sourcesContent":["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\nbutton,\nhr,\ninput {\n\toverflow: visible;\n}\nprogress,\nsub,\nsup {\n\tvertical-align: baseline;\n}\n[type='checkbox'],\n[type='radio'],\nlegend {\n\tbox-sizing: border-box;\n\tpadding: 0;\n}\nhtml {\n\tline-height: 1.15;\n\t-webkit-text-size-adjust: 100%;\n}\nbody {\n\tmargin: 0;\n\tbackground-color: blanchedalmond;\n}\ndetails,\nmain {\n\tdisplay: block;\n}\nh1 {\n\tfont-size: 2em;\n\tmargin: 0.67em 0;\n}\nhr {\n\tbox-sizing: content-box;\n\theight: 0;\n}\ncode,\nkbd,\npre,\nsamp {\n\tfont-family: monospace, monospace;\n\tfont-size: 1em;\n}\na {\n\tbackground-color: transparent;\n}\nabbr[title] {\n\tborder-bottom: none;\n\ttext-decoration: underline;\n\ttext-decoration: underline dotted;\n}\nb,\nstrong {\n\tfont-weight: bolder;\n}\nsmall {\n\tfont-size: 80%;\n}\nsub,\nsup {\n\tfont-size: 75%;\n\tline-height: 0;\n\tposition: relative;\n}\nsub {\n\tbottom: -0.25em;\n}\nsup {\n\ttop: -0.5em;\n}\nimg {\n\tborder-style: none;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n\tfont-family: inherit;\n\tfont-size: 100%;\n\tline-height: 1.15;\n\tmargin: 0;\n}\nbutton,\nselect {\n\ttext-transform: none;\n}\n[type='button'],\n[type='reset'],\n[type='submit'],\nbutton {\n\t-webkit-appearance: button;\n}\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner,\nbutton::-moz-focus-inner {\n\tborder-style: none;\n\tpadding: 0;\n}\n[type='button']:-moz-focusring,\n[type='reset']:-moz-focusring,\n[type='submit']:-moz-focusring,\nbutton:-moz-focusring {\n\toutline: ButtonText dotted 1px;\n}\nfieldset {\n\tpadding: 0.35em 0.75em 0.625em;\n}\nlegend {\n\tcolor: inherit;\n\tdisplay: table;\n\tmax-width: 100%;\n\twhite-space: normal;\n}\ntextarea {\n\toverflow: auto;\n}\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n\theight: auto;\n}\n[type='search'] {\n\t-webkit-appearance: textfield;\n\toutline-offset: -2px;\n}\n[type='search']::-webkit-search-decoration {\n\t-webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n\t-webkit-appearance: button;\n\tfont: inherit;\n}\nsummary {\n\tdisplay: list-item;\n}\n[hidden],\ntemplate {\n\tdisplay: none;\n}\n\n/* <uniquifier>: Use a unique and descriptive class name\n<weight>: Use a value from 100 to 900 */\n\n.inter-bold {\n\tfont-family: 'Inter', sans-serif;\n\tfont-optical-sizing: auto;\n\tfont-weight: 500;\n\tfont-style: normal;\n\tfont-variation-settings: 'slnt' 0;\n}\n\nbody {\n\tfont-family: 'Inter', sans-serif;\n\tfont-optical-sizing: auto;\n\tfont-weight: 300;\n\tfont-style: normal;\n\tfont-variation-settings: 'slnt' 0;\n\tcolor: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
